import React from "react";

/**
 * Honeypot — a hidden input that real users will never touch but bots
 * tend to fill in automatically. Pass `value` + `onChange` and forward
 * the value to the API. Server rejects submissions where it's non-empty.
 *
 * Hidden via inline styles (resilient to CSS overrides), removed from
 * tab order, marked aria-hidden so screen readers ignore it.
 */
const hiddenStyle = {
  position: "absolute",
  left: "-10000px",
  top: "auto",
  width: "1px",
  height: "1px",
  overflow: "hidden",
  opacity: 0,
  pointerEvents: "none",
};

export default function Honeypot({ value, onChange, name = "company_website_alt" }) {
  return (
    <div aria-hidden="true" style={hiddenStyle}>
      <label>
        Company website (do not fill)
        <input
          type="text"
          name={name}
          tabIndex={-1}
          autoComplete="off"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      </label>
    </div>
  );
}
